'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _Macroclimate = require('./Macroclimate50.css');

var _Macroclimate2 = _interopRequireDefault(_Macroclimate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Macroclimate50 = (_dec = (0, _reactCssModules2.default)(_Macroclimate2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Macroclimate50, _Component);

  function Macroclimate50(props) {
    (0, _classCallCheck3.default)(this, Macroclimate50);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Macroclimate50.__proto__ || (0, _getPrototypeOf2.default)(Macroclimate50)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Macroclimate50, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Macroclimate 50';
      var description = "Get your money out of fossil fuels. Use Fossil Free Funds to find out if you're invested in the largest coal-fired power plants.";
      var url = _config2.default.domain + _config2.default.routes.macroclimate50;

      var bannerImage = 'coal';
      var bannerHeadline = 'Macroclimate® 50';
      var bannerSubtitle = 'Public company owners of coal-fired power plants';
      var logoFirst = 'fff';
      var logoSecond = 'mc50';

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'image-banner-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-' + bannerImage },
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-headline' },
                bannerHeadline
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-subtitle' },
                bannerSubtitle
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                'Find out if you\'re invested in 50 of the largest owners of coal-fired power plants'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Coal is among the largest sources of global warming pollution in the world. Obtaining it destroys mountains, burning it releases hazardous emissions, and disposing of it results in hazardous toxic waste. Coal is scorching the planet and leaving a legacy of devastation in its wake.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'That\u2019s why we partnered with ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.macroclimate, xstrong: true, title: 'Macroclimate' },
                  'Macroclimate',
                  _react2.default.createElement(
                    'small',
                    null,
                    _react2.default.createElement(
                      'sup',
                      null,
                      '\xAE'
                    )
                  )
                ),
                ' to screen mutual funds for the ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.mc50, xstrong: true, title: 'Macroclimate 50' },
                  'Macroclimate',
                  _react2.default.createElement(
                    'small',
                    null,
                    _react2.default.createElement(
                      'sup',
                      null,
                      '\xAE'
                    )
                  ),
                  ' 50'
                ),
                ' \u2013 an exclusion list of the 50 largest public-company owners of coal-fired power plants in Developed Markets plus China and India.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Macroclimate',
                _react2.default.createElement(
                  'sup',
                  null,
                  '\xAE'
                ),
                ' compiled the list of 50 companies using open-source data on coal-fired power plants worldwide. These companies are emitting massive amounts of CO',
                _react2.default.createElement(
                  'sub',
                  null,
                  '2'
                ),
                ' and fueling climate change - and given coal\u2019s volatility and unsustainable business model, it is becoming an increasingly risky investment.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.mc50,
                    xstrong: true,
                    title: 'Macroclimate 50' },
                  'Visit Macroclimate',
                  _react2.default.createElement(
                    'small',
                    null,
                    _react2.default.createElement(
                      'sup',
                      null,
                      '\xAE'
                    )
                  ),
                  ' to learn more about the list',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'double-logo-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'double-logo' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'logo-first-wrap' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.about,
                        title: 'Fossil Free Funds, a project of As You Sow' },
                      _react2.default.createElement('div', {
                        styleName: 'logo-' + logoFirst,
                        title: 'Fossil Free Funds, a project of As You Sow'
                      })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'logo-second-wrap' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.macroclimate,
                        title: 'Macroclimate'
                      },
                      _react2.default.createElement('div', {
                        styleName: 'logo-' + logoSecond,
                        title: 'Macroclimate'
                      })
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null),
          _react2.default.createElement(
            'div',
            { styleName: 'x-mc50experts-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-mc50experts-container' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-mc50experts-container-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-mc50experts-info-photo' },
                  _react2.default.createElement('div', {
                    styleName: 'x-mc50experts-photo',
                    title: 'Climate experts: The #1 problem is coal power'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-mc50experts-info' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'x-mc50experts-info-title' },
                      'The #1 problem is coal power'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        { to: _config2.default.links.mc50experts, xstrong: true, title: 'Vision Prize: Expert Panel Findings' },
                        'A majority of expert panelists (64%)'
                      ),
                      ' in 2014 believed that retiring (or sequestering) coal-fired power plants would be the single most effective use of major investments to limit global warming and the vast majority (84%) expected that coal-fired power plants alone will contribute between 25% and 60% or more of gross carbon emissions to the atmosphere between then and 2020. This is due in large part to the proliferation of new coal plants in China and in India. China and India have increased from less than a third of The Macroclimate\xAE 50 companies to now making up one half of the list.'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-methodology-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-methodology-container' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-methodology-container-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-methodology-info-photo' },
                  _react2.default.createElement('div', {
                    styleName: 'x-methodology-photo',
                    title: 'Macroclimate 50 methodology'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-methodology-info' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'x-methodology-info-title' },
                      'Methodology'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Macroclimate periodically compiles extracts from ',
                      _react2.default.createElement(
                        _components.Link,
                        { to: 'https://globalenergymonitor.org/projects/global-coal-plant-tracker/', xstrong: true, title: 'Global Coal Plant Tracker' },
                        'Global Coal Plant Tracker'
                      ),
                      ', associates owners of the largest operating plants (including planned and new construction) in the relevant geographic areas with their respective publicly-traded companies, excludes companies rapidly phasing out their coal fleet in alignment with the Paris Agreement, and then ranks the remaining companies by their total coal-fired energy capacity (MWe). ',
                      _react2.default.createElement(
                        _components.Link,
                        { to: _config2.default.links.mc50, xstrong: true, title: 'Macroclimate 50 methodology' },
                        'See the full methodology',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(_components.AboutBanner, null)
              )
            )
          )
        )
      );
    }
  }]);
  return Macroclimate50;
}(_react.Component)) || _class);
exports.default = Macroclimate50;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Macroclimate50/Macroclimate50.js
// module id = 1413
// module chunks = 0